import _defineProperty from "/home/runner/work/presentations/presentations/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/presentations/presentations/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Box from '../Box';
import { merge } from '../sx';
import Truncate from '../Truncate';
import { Slot } from './Item';
export var Description = function Description(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'inline' : _ref$variant,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = {
    fontSize: 0,
    lineHeight: '16px',
    flexGrow: 1,
    flexBasis: 0,
    minWidth: 0,
    marginLeft: variant === 'block' ? 0 : 2
  };
  return /*#__PURE__*/React.createElement(Slot, {
    name: variant === 'block' ? 'BlockDescription' : 'InlineDescription'
  }, function (_ref2) {
    var blockDescriptionId = _ref2.blockDescriptionId,
        inlineDescriptionId = _ref2.inlineDescriptionId,
        disabled = _ref2.disabled;
    return variant === 'block' ? /*#__PURE__*/React.createElement(Box, {
      as: "span",
      sx: merge(_objectSpread(_objectSpread({}, styles), {}, {
        color: disabled ? 'fg.disabled' : 'fg.muted'
      }), sx),
      id: blockDescriptionId
    }, props.children) : /*#__PURE__*/React.createElement(Truncate, {
      id: inlineDescriptionId,
      sx: merge(_objectSpread(_objectSpread({}, styles), {}, {
        color: disabled ? 'fg.disabled' : 'fg.muted'
      }), sx),
      title: props.children,
      inline: true,
      maxWidth: "100%"
    }, props.children);
  });
};
Description.displayName = "Description";